import * as React from "react";
import SetInterval from "set-interval";
import { Link } from "react-router-dom";
import * as moment from "moment";
import * as Styled from "@tunnel-components/@sharded/@styled/styled";
import { Shake } from 'reshake';
import * as Utils from "@Cyclope-Utils/index";
import WarningPoint from "./alerte_orange_point.svg";
import WarningSansPoint from "./alerte_orange_sans_point.svg";
import Warning from "./alerte_orange.svg";
import Cloche from "./cloche";
import Fermer from "./fermer.svg";

const TunnelToken = (): any =>
  Utils.localStorageIsKeyExist() && Utils.localStorageIsKeyExist();

const fetchWithTimeout = async (resource: string, timeout: number = 500) => {
  const controller = new AbortController();
  const id = setTimeout(() => controller.abort(), timeout);

  const response = await fetch(resource, {
    method: "GET",
    cache: "default",
    headers: {
      Accept: "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: String("Bearer " + TunnelToken()),
      "Content-Type": "application/json",
    },
    signal: controller.signal,
  });
  clearTimeout(id);

  return response;
};

class Component extends React.PureComponent<any, any> {
  public constructor(props: any) {
    super(props);
    
    const inProgressMemoStr = window.sessionStorage.getItem("notifs_memo") || "[]";
    const inProgress = JSON.parse(inProgressMemoStr);
    this.state = { inProgress, terminated: [], open: false, shake: false, inMenu: false };

    this.loadCameras = this.loadCameras.bind(this);
    this.decreaseTimer = this.decreaseTimer.bind(this);
    this.hideNotif = this.hideNotif.bind(this);
    this.toggleOpen = this.toggleOpen.bind(this);
    this.close = this.close.bind(this);
    this.delayedClose = this.delayedClose.bind(this);
    this.inMenu = this.inMenu.bind(this);
    this.outMenu = this.outMenu.bind(this);
  }

  public toggleOpen() {
    const { inProgress, terminated } = this.state;
    if (inProgress.length > 0 || terminated.length > 0) {
      this.setState((state: any) => ({ ...state, open: !state.open }));
    }
  }

  public close() {
    this.setState((state: any) => ({ ...state, open: false }));
  }  

  public delayedClose() {
    setTimeout(() => {
      if (!this.state.inMenu) {
        this.setState((state: any) => ({ ...state, open: false }));
      }
    }, 500)
  }

  public inMenu() {
    this.setState((state: any) => ({ ...state, inMenu: true }))
  }

  public outMenu() {
    this.setState((state: any) => ({ ...state, inMenu: false, open: false }))
  }

  public async loadCameras() {
    const CFG_NAMESPACE = "env";
    const BASE_URL = window[CFG_NAMESPACE].API_URL_STATIC;  
    try {
      const res = await fetchWithTimeout(`${BASE_URL}/cameras/find-light-auto-segmentation`, this.props.timeout);
      // console.log('load');
      let blacklist = [];
      const fromStorage = window.sessionStorage.getItem('notifs_blacklist');
      if (fromStorage) {
        blacklist = JSON.parse(fromStorage);
      }

      let resJSON = [];
      if (res.ok) {
        resJSON = await res.json();
      } else {
        throw new Error();
      }

      const sorter = (c1: any, c2: any) => {
        if (moment(c1.moveDate.split(' ').join('T')).unix() > moment(c2.moveDate.split(' ').join('T')).unix()) {
          return -1;
        } else if (moment(c1.moveDate.split(' ').join('T')).unix() < moment(c2.moveDate.split(' ').join('T')).unix()) {
          return 1;
        }
        return 0;
      };

      const inProgress = resJSON
      .filter((c: any, idx) => c.viewMove && c.segProcess)
      .map((c: any) => {
        const blackListed = typeof blacklist[c.code] !== "undefined";
        // const prev = this.state.inProgress.find((pc: any) => pc.id === c.id);
        if (blackListed) {
          return { ...c, timer: blacklist[c.code] };
        }
        // const timer = !prev ? this.props.popup_hiding_delay : prev.timer;
        const timer = this.props.popup_hiding_delay;
        return { ...c, timer }; 
      })
      .sort(sorter);

      // console.log('inProgress', inProgress);
      window.sessionStorage.setItem("notifs_memo", JSON.stringify(inProgress));

      this.setState((state) => ({
        ...state,
        inProgress,
        terminated: resJSON
                      .filter((c: any, idx) => c.viewMove && !c.segProcess)
                      .sort(sorter),
      }));
    } catch (error) {
      // console.log('net error');
    }
  }

  public decreaseTimer() {
    this.setState(
      (state: any) => ({ ...state, inProgress: state.inProgress.map((c: any) => ({ ...c, timer: c.timer -1 }))})
    )
  }

  public hideNotif(id) {
    this.setState(
      (state: any) => 
        ({
          ...state,
          inProgress: state.inProgress.map((c: any) => ({ ...c, timer: c.id === id ? 0 : c.timer }))
        })
    )
  }

  public componentDidUpdate(prevProps: any, prevState: any) {
    const { inProgress } = this.state;
    const blacklistStr = window.sessionStorage.getItem('notifs_blacklist') || "{}";
    const blacklist = JSON.parse(blacklistStr);
    // console.log('blacklist', blacklist);
    const toBlacklist = inProgress
                      .filter((c: any) => c.timer === 0 && !blacklist[c.code])
                      .map((c: any) => c.code);

    // console.log('toBlacklist',toBlacklist);
    const newBlacklist = Object.keys(blacklist)
                          .filter((k: string) => blacklist[k] > -900)
                          .reduce((memo: any, k: string) => ({ ...memo, [k]: blacklist[k] - 1 }), {});

    // console.log('newBlacklist', newBlacklist);
    toBlacklist.forEach((b: any) => newBlacklist[b] = -1);
    // console.log('newblacklist', newBlacklist);

    window.sessionStorage.setItem("notifs_blacklist", JSON.stringify(newBlacklist));

    if (inProgress.length > prevState.inProgress.length && !this.state.shake) {
      this.setState((state) => ({ ...state, shake: true }));
      setTimeout(() => this.setState((state) => ({ ...state, shake: false })), 2500);
    }
  }

  public componentDidMount() {
    this.loadCameras();
    SetInterval.start(this.loadCameras, this.props.polling_delay * 60000, "loadCameras");
    SetInterval.start(this.decreaseTimer, 1000, "decreaseTimer");
  }

  public componentWillUnmount() {
    // console.log('unmount');    
    SetInterval.clear("loadCameras");
    SetInterval.clear("decreaseTimer");
  }

  public render() {
    const { inProgress, terminated, shake } = this.state;
    const lastNotifs = inProgress.filter((c:any) => c.timer > 0);

    return <>
      {!this.state.open && lastNotifs.map((c: any, idx: number) => (
        <div key={idx} style={{
          position: "absolute",
          top: 65 + (idx * 75),
          right: 0,
          width: 300,
          height: 55,
          backgroundColor: "#fff",
          boxShadow: "rgb(182 179 179 / 59%) -4px 8px 15px 0px",
          borderRadius: 4,
          fontSize: "0.8em",
          padding: "0px 0px 15px"
        }}
        // tslint:disable-next-line:jsx-no-lambda
        onClick={() => this.hideNotif(c.id)}
        >
          <div style={{ paddingTop: 2,  paddingRight: 2, textAlign: "right"}}><img src={Fermer} alt="x" /></div>
          <div style={{
            display: "flex",
            justifyItems: "flex-start",
          }}>
            <div style={{
              textAlign: "center",
              width: "50px"
            }}>
              <img src={Warning} alt="warning" height={30} width="auto"/>
            </div>
            <div style={{ padding: 0,textAlign: "left"}}>
              <span style={{ color: "#000"}}>"Bougé caméra" sur {c.code}</span><br />
              <span style={{ color: "grey"}}>{moment(c.moveDate.split(' ').join('T')).fromNow()}</span>
            </div>
          </div>
          <div style={{ minHeight: 10}} />
        </div>
      ))}
      <div
        className="headerInfostitle"
        style={{ border: "none", top: "4px" }}
        onClick={this.toggleOpen}
        onMouseLeave={this.delayedClose}        
      >
        <Styled.Icon style={{ width: "25px", right: 0 }}>
        <Shake 
          h={5}
          v={5}
          r={3}
          dur={310}
          int={10}
          max={100}
          fixed={true}
          fixedStop={false}
          freez={false}
          active={shake}
        >
          <Cloche nombre={inProgress.length} />
        </Shake>
            
        </Styled.Icon>
      </div>
      <Styled.BreadBoxContainer
        isVisible={this.state.open}
        style={{
          right: -15,
          color: "black",
          minWidth: "500px",
          top: 55,
          padding: 5,
          textAlign: "left",
          boxShadow: "#b6b3b396 -2px 18px 30px 0px",
          borderRadius: "10px",
        }}
        onMouseLeave={this.outMenu}        
        onMouseEnter={this.inMenu}        
      >
        <h1 style={{
            fontWeight: "bold",
            letterSpacing: 1,
            fontSize: "1.8em",
            color: "#0080f4",
            padding: 15
        }}>Notifications</h1>
        {inProgress.length > 0 && <h2 style={{
            fontWeight: "bold",
            letterSpacing: 1,
            color: "grey",
            padding: "0px 35px 10px"
        }}>En cours</h2>}
        {inProgress.length > 0 && <div style={{
          maxHeight: "250px",
          overflow: "hidden",
          overflowY: "auto",
        }}>
          {inProgress.map((c: any) => (
            <div style={{ marginBottom: "10px", padding: "5px 30px"}}>
                <div style={{ textAlign: "right"}}>
                  <span style={{ fontSize: "0.8em", color: "grey"}}>{moment(c.moveDate.split(' ').join('T')).fromNow()}</span>              
                </div>
              <div style={{
                display: "flex",
                justifyItems: "flex-start",
                alignItems: "center"
              }}>                
                <div style={{
                  textAlign: "center",
                  padding: 5
                }}>
                  <img src={WarningPoint} alt="warning" style={{ height: "100%", width: "auto"}}/>
                </div>  
                <div style={{ padding: 5,textAlign: "left", flexGrow: 1, color: "#000"}}>
                    "Bougé caméra" sur {c.code}. Recalcul du masque en cours.
                </div>                    
              </div>
              <div style={{ textAlign: "right"}}>
                <Link to={`/supervision/camera/parametres/${c.id}`} style={{
                  textAlign: "center",
                  color: "#fff",
                  padding: "10px",
                  backgroundColor: "#0080f4",
                  width: "200px",
                  borderRadius: "3px",
                  fontSize: "0.8em"
                }}>Accéder à la camera</Link>
              </div>
            </div>
          ))} 
        </div>}        
        {terminated.length > 0 && <h2 style={{
            fontWeight: "bold",
            letterSpacing: 1,
            color: "grey",
            padding: "30px 35px 10px"
        }}>Terminées</h2>}       
          {terminated.filter((c: any, idx: any) => idx < 2).map((c: any) => (
            <div style={{ marginBottom: "10px", padding: "5px 30px"}}>
              <div style={{ textAlign: "right"}}>
                <span style={{ fontSize: "0.8em", color: "grey"}}>{moment(c.moveDate.split(' ').join('T')).fromNow()}</span>              
              </div>
              <div style={{
                display: "flex",
                justifyItems: "flex-start",
                alignItems: "center"
              }}>
                <div style={{
                  textAlign: "center",
                  padding: 5
                }}>
                  <img src={WarningSansPoint} alt="warning" style={{ height: "100%", width: "auto"}}/>
                </div>  
                <div style={{ padding: 5,textAlign: "left", flexGrow: 1, color: "#000"}}>
                    "Bougé caméra" sur {c.code}. Le masque a été recalculé.
                </div>                    
              </div>
              <div style={{ textAlign: "right"}}>
                <Link to={`/supervision/camera/parametres/${c.id}`} style={{
                  textAlign: "center",
                  color: "#fff",
                  padding: "10px",
                  backgroundColor: "#0080f4",
                  width: "200px",
                  borderRadius: "3px",
                  fontSize: "0.8em"
                }}>Accéder à la camera</Link>
              </div>
            </div>
          ))}           
      </Styled.BreadBoxContainer>
    </>
  }
}

export default Component;



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/notifications/index.tsx